<script lang="ts">
  import { onMount } from 'svelte';
  import { store } from '../store.svelte';

  let visible = $state(true);
  onMount(() => {
    const t = setTimeout(() => (visible = false), 6000);
    return () => clearTimeout(t);
  });
</script>

{#if visible && !store.helpOpen && !store.openId}
  <button
    class="hint"
    onclick={() => store.toggleHelp(true)}
    aria-label="Показать горячие клавиши"
  >
    <kbd>?</kbd> клавиши
  </button>
{/if}

<style>
  .hint {
    position: fixed;
    bottom: 18px;
    right: 18px;
    z-index: 35;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: rgba(11, 10, 15, 0.75);
    backdrop-filter: blur(6px);
    border: 1px solid var(--hair);
    border-radius: 999px;
    padding: 6px 13px 6px 10px;
    color: var(--ink-dim);
    font-family: var(--mono);
    font-size: 0.6rem;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    cursor: pointer;
    transition: opacity 0.6s, color 0.25s, border-color 0.25s;
    animation: rise 0.5s ease both;
  }
  .hint:hover {
    color: var(--ink);
    border-color: var(--mercury);
  }
  kbd {
    font-family: var(--mono);
    font-size: 0.7rem;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid var(--hair);
    border-radius: 3px;
    padding: 1px 5px;
    color: var(--mercury);
  }
  @keyframes rise {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: none;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .hint {
      animation: none;
    }
  }
</style>
